import React from "react"
import CustomFooter from "../footer/CustomFooter"
import CustomPermissions from "../permissions/CustomPermissions"
import mayaPrivacy from "../../assets/mayaPrivacyText.txt"
import fundsTnC from "../../assets/fundsTnCText.txt"
import CustomTitle from "../title/CustomTitle"

function FundsConsent({ id, rrn, ticket, consents, redirect }) {
  const FundsTitle = <CustomTitle merchantName={ticket.tp.name} />
  const FundsPermissions = (
    <CustomPermissions sharedInformation={ticket.tp.sharedInformation} />
  )
  return (
    <>
      {FundsTitle}
      <div className="container-flex">{FundsPermissions}</div>
      <CustomFooter
        id={id}
        rrn={rrn}
        opt={consents}
        redirect={redirect}
        privacyText={mayaPrivacy}
        tncText={fundsTnC}
      />
    </>
  )
}

export default FundsConsent
